import {
	BaseError,
} from './BaseError';

export class GetCompanyBuildingListError extends BaseError {
	constructor(message: string, stack?: string) {
		super(message, stack);
	}
}
